import React from "react";
import siteConfig from "../config/siteConfig";
import PolicyLayout from "./PolicyLayout";

const privacySections = [
  {
    title: "Information we collect",
    body: [
      `When you browse or buy from ${siteConfig.brandName}, we may collect contact, delivery, account and order information that you provide. We also receive basic device and browsing data, such as pages viewed, browser type and approximate location, through cookies and similar technologies.`,
      "Payment details are handled by the payment provider shown at checkout. We do not intentionally store complete payment card numbers in this front-end experience.",
    ],
  },
  {
    title: "How we use information",
    body: [
      "We use personal information only where it is reasonably needed to operate, improve and protect our service.",
    ],
    items: [
      "To process payment, prepare orders and arrange delivery.",
      "To answer questions, manage returns and provide product support.",
      "To remember preferences and improve store performance and accessibility.",
      "To prevent fraud, secure the site and meet legal or accounting obligations.",
    ],
  },
  {
    title: "Cookies and analytics",
    body: [
      "Essential cookies keep features such as the shopping bag working. Optional analytics or marketing cookies help us understand store use and measure campaigns. Where required, you can accept or reject optional cookies through the consent controls shown on the site or in your browser settings.",
    ],
  },
  {
    title: "When information is shared",
    body: [
      "We may share the minimum necessary information with trusted providers that support hosting, payment, fulfilment, delivery, customer care, analytics and email. They may use it only to provide those services or meet their own legal duties.",
      "We may also disclose information when the law requires it, to protect customers and our service, or as part of a business reorganisation. We do not sell personal information for money.",
    ],
  },
  {
    title: "Retention and security",
    body: [
      "We retain information only for as long as it serves the purposes described here, including customer care, tax, accounting and dispute-resolution needs. We use reasonable organisational and technical safeguards, but no internet transmission or storage system can be guaranteed completely secure.",
    ],
  },
  {
    title: "Your choices and rights",
    body: [
      `You may ask to access or correct personal information we hold about you, or raise a privacy concern by emailing ${siteConfig.contact.email}. We may need to verify your identity before completing a request.`,
      "Your rights depend on the law that applies to you. We will respond in line with applicable requirements and explain if an exception prevents us from fulfilling part of a request.",
    ],
  },
  {
    title: "Updates to this policy",
    body: [
      "We may revise this notice when our services, providers or legal obligations change. The version published on this page is the current one, and material changes will be highlighted where appropriate.",
    ],
  },
];

function Privacy() {
  return (
    <PolicyLayout
      eyebrow="Legal"
      title="Privacy policy"
      intro={`Your trust matters. This notice explains how ${siteConfig.brandName} handles personal information when you visit or shop with us.`}
      sections={privacySections}
    />
  );
}

export default Privacy;
